import React from "react";
import Button from "material-ui/Button";
import SortIcon from "material-ui-icons/Sort";
import AccessTimeIcon from "material-ui-icons/AccessTime";
import { SORT_BY } from "./actions/sort";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  disabled: {
    color: theme.palette.action.disabled
  },
  buttonShape: {
    height: 36
  }
});

const SortPeopleToggle = props => {
  const { sortBy, onSortBy, classes } = props;

  const handleClick = event => {
    if (sortBy === SORT_BY.DATE_DESC) {
      onSortBy("role");
    } else {
      onSortBy("date");
    }
  };

  const roleIconClass = sortBy === SORT_BY.ROLE ? "" : classes.disabled;
  const timeIconClass = sortBy === SORT_BY.DATE_DESC ? "" : classes.disabled;

  return (
    <Button
      color="primary"
      onClick={handleClick}
      className={classes.buttonShape}
    >
      <SortIcon className={roleIconClass} />{" "}
      <AccessTimeIcon className={timeIconClass} />
    </Button>
  );
};
SortPeopleToggle.propTypes = {
  sortBy: PropTypes.string.isRequired,
  onSortBy: PropTypes.func.isRequired
};

export { SortPeopleToggle };

export default withStyles(styles, { name: "SortPeopleToggle" })(
  SortPeopleToggle
);



// WEBPACK FOOTER //
// ./src/SortPeopleToggle.js